import PacingIcon from './component.jsx'
export default PacingIcon
